<div mat-dialog-content>
  <h2>Du har allerede registrert en MobilPant</h2>
  <p>Vil du slette den og opprette ny?</p>
</div>

<div mat-dialog-actions>
  <div class="buttons">
    <app-ice-button color="outlined" size="medium" testId="trade-in-reset-abort-button" (click)="abort()">
      Behold eksisterende
    </app-ice-button>
    <app-ice-button color="secondary" size="medium" testId="trade-in-reset-confirm-button" (click)="confirmReset()">
      Slett og lag en ny
    </app-ice-button>
  </div>
</div>
